export default __webpack_public_path__ + "static/media/login-banner.7d348713.png";